export const INSERT_CANNED_REPLY_REQUEST =
  'cannedReplies/INSERT_CANNED_REPLY_REQUEST'
export const INSERT_CANNED_REPLY = 'cannedReplies/INSERT_CANNED_REPLY'

export const FETCH_CANNED_REPLY_CATEGORIES =
  'cannedReplies/FETCH_CANNED_REPLY_CATEGORIES'
export const FETCH_CANNED_REPLY_CATEGORIES_STARTED =
  'cannedReplies/FETCH_CANNED_REPLY_CATEGORIES_STARTED'
export const FETCH_CANNED_REPLY_CATEGORIES_SUCCESS =
  'cannedReplies/FETCH_CANNED_REPLY_CATEGORIES_SUCCESS'
export const FETCH_CANNED_REPLY_CATEGORIES_FAILED =
  'cannedReplies/FETCH_CANNED_REPLY_CATEGORIES_FAILED'

export const FETCH_CANNED_REPLIES = 'cannedReplies/FETCH_CANNED_REPLIES'
export const FETCH_CANNED_REPLIES_STARTED =
  'cannedReplies/FETCH_CANNED_REPLIES_STARTED'
export const FETCH_CANNED_REPLIES_SUCCESS =
  'cannedReplies/FETCH_CANNED_REPLIES_SUCCESS'
export const FETCH_CANNED_REPLIES_FAILED =
  'cannedReplies/FETCH_CANNED_REPLIES_FAILED'

export const TOGGLE_CANNED_REPLY_COLLAPSED_STATE =
  'cannedReplies/TOGGLE_CANNED_REPLY_COLLAPSED_STATE'

export const SET_TEMPLATE_SEARCH_TERM = 'cannedReplies/SET_TEMPLATE_SEARCH_TERM'
export const CLEAR_TEMPLATES = 'cannedReplies/CLEAR_TEMPLATES'
